import { Injectable } from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {DataService} from './data.service';
import {ApiServices} from './api.service';
import {Brand} from '../interfaces/wheels';
import {ToastrService} from 'ngx-toastr';
import {Page} from '../interfaces/Page.interface';
import {BaseImagePipe} from '../pipes/base-image.pipe';
import {Router} from '@angular/router';
import { MyProfile } from '../interfaces/MyAccount.interface';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor(
    private title: Title,
    private dataService: DataService,
    private toastr: ToastrService,
    private meta: Meta,
    private apiService: ApiServices,
    private router: Router
  ) { }

  setPageTitle  = (title) => this.title.setTitle(title);

  setVehicleWheelParams = (data) => {
    const wheel = data[0].wheels.find(x => x.is_stock);
    const vehicleData: any = {
      // centre_bore: data[0].centre_bore,
      // generation: data[0].generation.name,
      bolt_pattern: data[0].technical.bolt_pattern,
      rim_diameter: wheel.front.rim_diameter,
      // diameter: wheel.front.rim_diameter,
      // tire_aspect_ratio: data[0].wheels[0].front.tire_aspect_ratio,
      // width: wheel.front.rim_width,
      // rim_width: wheel.front.rim_width,
      // checkfitment: 'checkfitment'
    };

    this.dataService.diameter.next(wheel.front.rim_diameter);

    return vehicleData;
  }

  // setVehicleWheelParams = (data) => {
  //   const wheel = data[0].wheels.find(x => x.is_stock);
  //   const vehicleData: any = {
  //     // centre_bore: data[0].centre_bore,
  //     // generation: data[0].generation.name,
  //     bolt_pattern: data[0].bolt_pattern,
  //     rim_diameter: wheel.front.rim_diameter,
  //     diameter: wheel.front.rim_diameter,
  //     // tire_aspect_ratio: data[0].wheels[0].front.tire_aspect_ratio,
  //     width: wheel.front.rim_width,
  //     // checkfitment: 'checkfitment'
  //   };

  //   this.dataService.diameter.next(wheel.front.rim_diameter);

  //   return vehicleData;
  // }

  deliveryDate = (countryCode, brand: Brand) => {
    let deliveryDays: number;
    switch (countryCode) {
      case 'AE':
        deliveryDays = brand.uae;
        break;
      case 'KW':
        deliveryDays = brand.kuwait;
        break;
      case 'SA':
        deliveryDays = brand.ksa;
        break;
      case 'OM':
        deliveryDays = brand.oman;
        break;
      case 'BHR':
        deliveryDays = brand.bahrain;
        break;
      default:
        deliveryDays = brand.uae;
        break;
    }

    const deliveryDate = new Date();
    if (deliveryDays) {
      deliveryDate.setDate(deliveryDate.getDate() + Number(deliveryDays));
    }
    return deliveryDate;
  }


  generateSessionId(): void {
    let result           = '';
    const characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for ( let i = 0; i < 15; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    localStorage.setItem('session_id', result);
  }

  showErrors(error): void {
    // First check if this is actually a success response
    if (error && error.status === true) {
      // This is not an error but a successful response
      return;
    }
    
    // Special case for vendor-request endpoint
    if (error && error.config && error.config.url && error.config.url.includes('vendor-request')) {
      return;
    }
    
    if (error.hasOwnProperty('error')) {
      if (error.error.errors && error.error.errors instanceof Array) {
        this.toastr.error(error.error.errors[0]);
      } else if (error.error.hasOwnProperty('message')) {
        this.toastr.error(error.error.message);
      } else {
        this.toastr.error('Something went wrong, please try again');
      }
    } else if (error.hasOwnProperty('message')) {
      // Direct message property on the error object
      this.toastr.error(error.message);
    }
  }

  setPageMeta(page: Page): void {
    this.removeMetaInfo();
    this.meta.updateTag({name: 'title', content: page.title});
    this.meta.updateTag({name: 'og:title', content: page.title});
    this.meta.updateTag({name: 'twitter:title', content: page.title});

    this.meta.updateTag({name: 'description', content: `${page.body}`});
    this.meta.updateTag({name: 'og:description', content: `${page.body}`});
    this.meta.updateTag({name: 'twitter:description', content: `${page.body}`});

    this.meta.updateTag({name: 'og:site_name', content: 'Clockwork.app'});
    this.meta.updateTag({name: 'twitter:card', content: 'summary_large_image'});
    this.meta.updateTag({name: 'twitter:site', content: 'Clockwork.app'});

    this.meta.updateTag({name: 'og:image', property: 'og:image', content: page.image});
    this.meta.updateTag({name: 'twitter:image', content: page.image});
  }

  setCustomMeta(metaData: any): void {
    this.removeMetaInfo();
    this.meta.updateTag({name: 'title', content: metaData.title});
    this.meta.updateTag({name: 'og:title', content: metaData.title});
    this.meta.updateTag({name: 'twitter:title', content: metaData.title});

    this.meta.updateTag({name: 'description', content: `${metaData.description}`});
    this.meta.updateTag({name: 'og:description', content: `${metaData.description}`});
    this.meta.updateTag({name: 'twitter:description', content: `${metaData.description}`});

    this.meta.updateTag({name: 'og:site_name', content: 'Clockwork.app'});
    this.meta.updateTag({name: 'twitter:card', content: 'summary_large_image'});
    this.meta.updateTag({name: 'twitter:site', content: 'Clockwork.app'});

    if (metaData.keywords) {
      this.meta.updateTag({name: 'keywords', content: metaData.keywores});
    }

  }

  removeMetaInfo(): void {
    this.meta.removeTag('name=title');
    this.meta.removeTag('name=keywords');
    this.meta.removeTag('name=description');
    this.meta.removeTag('name="og:title"');
    this.meta.removeTag('name="twitter:title"');
    this.meta.removeTag('name="og:description"');
    this.meta.removeTag('name="twitter:description"');
    this.meta.removeTag('name="og:site_name"');
    this.meta.removeTag('name="twitter:site"');
    this.meta.removeTag('name="twitter:card"');
    this.meta.removeTag('name="og:type"');
    this.meta.removeTag('name="og:id"');
    this.meta.removeTag('name="og:url"');
    this.meta.removeTag('name="og:image"');
    this.meta.removeTag('name="twitter:image"');
    this.meta.removeTag('name="twitter:id"');
  }

  scrollToTop = (x = 0, y = 0) => {
    window.scrollTo(x, y);
  };
  getMyAccountData(): void {
    this.apiService.myAccount().subscribe(
      response => {
        console.log('📥 API Response:', response);
        this.dataService.myAccountData.next(response.data);
      }, error => {
        this.logout();
        this.showErrors(error);
      }
    );
  }

  logout(): void {
    localStorage.clear();
    this.router.navigateByUrl('/');
    this.dataService.isLoggedIn.next(false);
  }

  isSubscribed(profileData: MyProfile, planSlug: string) {
    if(profileData && profileData._subscriptions) {
      // Handle former plus-plan subscribers as premium
      if(planSlug === 'premium-plan' && profileData._subscriptions['plus-plan']) {
        return true;
      }
      return profileData._subscriptions[planSlug];
    }

    return false;
  }
  hasPremiumFeatures(profileData: MyProfile) {
    if(profileData && profileData._subscriptions) {
      // Check both premium and plus plans (for legacy users)
      return profileData._subscriptions['premium-plan'] || profileData._subscriptions['plus-plan'];
    }
    return false;
  }
  // New feature-based plan checking methods
  canAccessFeature(profileData: MyProfile, featureKey: string): boolean {
    console.log('🔍 canAccessFeature called with:', { profileData, featureKey });
    
    if (!profileData || !profileData.plan) {
      console.log('❌ No profileData or plan found');
      return false;
    }

    // Check if plan has the requested feature
    const plan = profileData.plan;
    console.log('📋 Plan data:', plan);
    
    if (!plan.features) {
      console.log('❌ No plan features found');
      return false;
    }

    console.log('🎯 Available features:', plan.features);

    const feature = plan.features.find(f => f.feature_key === featureKey && f.is_active);
    console.log('🔎 Found feature:', feature);
    
    if (!feature) {
      console.log('❌ Feature not found or not active');
      return false;
    }    
    
    // Handle different feature types
    let result = false;
    switch (feature.feature_type) {
      case 'boolean':
        result = feature.feature_value === 'true' || feature.feature_value === '1';
        break;
      case 'unlimited':
        result = true;
        break;
      case 'numeric':
        result = parseInt(feature.feature_value) > 0;
        break;
      default:
        result = false;
    }
    
    console.log('✅ Feature access result:', result);
    return result;
  }

  // Specific feature access methods for common dashboard features
  canAddProducts(profileData: MyProfile): boolean {
    return this.canAccessFeature(profileData, 'add_products');
  }

  canManageSuppliers(profileData: MyProfile): boolean {
    return this.canAccessFeature(profileData, 'supplier_management');
  }

  canAccessAPIIntegration(profileData: MyProfile): boolean {
    return this.canAccessFeature(profileData, 'api_integration');
  }

  // Additional business feature methods
  canDownloadData(profileData: MyProfile): boolean {
    return this.canAccessFeature(profileData, 'download_data');
  }

  canUseCustomBranding(profileData: MyProfile): boolean {
    return this.canAccessFeature(profileData, 'custom_branding');
  }

  canHideCostPrice(profileData: MyProfile): boolean {
    return this.canAccessFeature(profileData, 'hide_cost_price');
  }

  // Secure method to determine if cost should be hidden
  shouldHideCost(profileData: MyProfile): boolean {
    // Security: Only hide cost if user has premium plan AND localStorage setting is enabled
    const hasPermission = this.canHideCostPrice(profileData);
    const localStorageSetting = localStorage.getItem("is_hide_cost") != null;
    const profileSetting = profileData?.is_hide_cost == 1;
    const overrideSetting = localStorage.getItem("override_cost_setting") == null;
    
    if (!hasPermission) {
      // Clear localStorage if user doesn't have permission
      localStorage.removeItem("is_hide_cost");
      return false;
    }
    
    return localStorageSetting || (profileSetting && overrideSetting);
  }

  hasUnlimitedOrders(profileData: MyProfile): boolean {
    return this.canAccessFeature(profileData, 'unlimited_orders');
  }

  // Legacy support - fallback to old plan checking if new feature system not available
  canAccessFeatureWithFallback(profileData: MyProfile, featureKey: string): boolean {
    // Try new feature-based system first
    if (profileData && profileData.plan && profileData.plan.features) {
      return this.canAccessFeature(profileData, featureKey);
    }    // Fallback to legacy plan checking for backward compatibility
    const featurePlanMapping = {
      'add_products': 'starter-plan',       // Starter plan feature
      'supplier_management': 'starter-plan', // Starter plan feature  
      'download_data': 'starter-plan',      // Starter plan feature
      'unlimited_orders': 'starter-plan',   // Starter plan feature
      'api_integration': 'premium-plan',    // Premium only feature
      'custom_branding': 'premium-plan',    // Premium only feature
      'hide_cost_price': 'premium-plan'     // Premium only feature
    };

    const requiredPlan = featurePlanMapping[featureKey];
    if (requiredPlan) {
      return this.isSubscribed(profileData, requiredPlan) || this.hasPremiumFeatures(profileData);
    }

    return false;
  }

  categoryFieldsMapping(categorySlug: string) {
    const slugFields = {
        'wheel-accessories': ['description'],
        'lug-nuts': ['thread_size', 'color', 'lug_nut_length', 'lug_nut_diameter'],
        'lug-bolts': ['thread_size', 'color', 'thread_length', 'lug_bolt_diameter'],
        'hub-rings': ['ext_center_bore', 'center_bore'],
        'spacers': ['bolt_pattern', 'width', 'thread_size', 'center_bore'],
        'tpms': ['description'],
    };

    return slugFields[categorySlug] || [];
  }
}
